module.exports = __webpack_public_path__ + "static/media/e57662ff-b1ef-4122-88c1-61bbdabeb365.4d45b628.woff";